import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GraphQLModule } from '../graphql.module'
import { TranslateModule } from '@ngx-translate/core'
import { RouterModule } from '@angular/router'
import { SbsCommonModule } from 'sbs-common'
import { environment } from '../../environments/environment'
import { MaterialModule } from './modules/material.module'
import { AppEntityListComponent } from './components/app-entity-list/app-entity-list.component'
import { NgxSpinnerModule } from 'ngx-spinner'
import { ChannelMessagingWrapperComponent } from './components/channel-messaging-wrapper/channel-messaging-wrapper.component'
import { LanguageToFlagPipe } from './pipes/language-to-flag.pipe'
import { CodeInputModule } from 'angular-code-input'
import { ActionApp } from '../../generated/graphql'
import { AppShowMoreParagraphComponent } from './components/app-show-more-paragraph/app-show-more-paragraph.component'
import { ZXingScannerModule } from '@zxing/ngx-scanner'
import { PwaPromptComponent } from './components/pwa-prompt/pwa-prompt.component'

export const components = [
  AppEntityListComponent,
  ChannelMessagingWrapperComponent,
  AppShowMoreParagraphComponent,
  PwaPromptComponent,
]
export const pipes = [LanguageToFlagPipe]

@NgModule({
  declarations: [...components, ...pipes],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    GraphQLModule,
    TranslateModule,
    RouterModule,
    MaterialModule,
    NgxSpinnerModule,
    CodeInputModule,
    SbsCommonModule.forRoot(environment, ActionApp.Chaser),
  ],
  providers: [DatePipe],
  exports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    GraphQLModule,
    TranslateModule,
    SbsCommonModule,
    MaterialModule,
    NgxSpinnerModule,
    CodeInputModule,
    ZXingScannerModule,
    ...components,
    ...pipes,
  ],
})
export class SharedModule {}
